import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import getTenantId from "../../components/Tenent";
import axios from "axios";
import { showAccessDeniedModal } from "../slices/authSlice";
const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

const setUpInterceptors = (getState, dispatch) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const parsedURL = new URL(window.location.href);

      const subdomain = parsedURL?.hostname?.split(".")?.[0];
      const tenantId = getTenantId();

      if (subdomain === "localhost") {
        config.headers["x-tenant-id"] = tenantId;
      } else {
        config.headers["x-tenant-id"] = subdomain;
      }
      const token = getState()?.auth?.accessToken;
      const refresh_token = getState()?.auth?.refreshToken;
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Refresh"] = `Bearer ${refresh_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

const axiosBaseQuery =
  () =>
  async (
    { url, method, body, params, ...requestOpts },
    { getState, dispatch }
  ) => {
    setUpInterceptors(getState, dispatch);
    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      const errorData = axiosError.response?.data;
      const status = axiosError.response?.status;

      if (status === 403 && errorData?.error === "forbidden") {
        getStore().dispatch(showAccessDeniedModal());
      }
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const activitiesApi = createApi({
  reducerPath: "activitiesApi",
  baseQuery: axiosBaseQuery(),
  // baseQuery: fetchBaseQuery({
  //   baseUrl: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  //   prepareHeaders: async (headers, { getState }) => {
  //     const token = await getState()?.auth?.activityAccessToken;
  //     if (token) {
  //       headers.set("Authorization", `Bearer ${token}`);
  //     }
  //     return headers;
  //   },
  // }),
  tagTypes: ["activities"],
  endpoints: (builder) => ({
    getToken: builder.mutation({
      query: () => ({
        url: `login`,
        method: "POST",
        body: {
          API_KEY: process.env.REACT_APP_ACTIVITIES_HOST_API_KEY,
        },
      }),
      invalidatesTags: ["activities"],
    }),
    getActivities: builder.query({
      query: ({ category, mapping_category, mapping_sector, token }) => {
        if (!category) {
          return;
        }
        return {
          url: `get_emission_units_factors?category=${category}&mapping_category=${mapping_category}&mapping_sector=${mapping_sector}&region=IN`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["activities"],
    }),
    getMapActivities: builder.query({
      query: ({ mapping_category, mapping_sector, token }) => {
        return {
          url: `get_activities?mapping_category=${mapping_category}&mapping_sector=${mapping_sector}&is_currency_match=1`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["activities"],
    }),
    manualMatch: builder.mutation({
      query: ({ token, body }) => {
        return {
          url: `/save_manual_match`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
        };
      },
      providesTags: ["activities"],
    }),
    getCategoryActivities: builder.query({
      query: ({ token, category, region, search }) => {
        if (!category) {
          return;
        }
        return {
          url: `get_activities`,
          // url: `get_activities?category=${category}&search=${search}&region=${region}&add_pagination=1&n_records=80`,
          params: {
            category,
            search,
            ...(!region ? {} : { region }),
            add_pagination: 1,
            n_records: 100,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["activities"],
    }),
    searchAllActivities: builder.query({
      query: ({ q, limit, page, token }) => {
        if (!q) {
          return;
        }
        return {
          url: `show_activities?search=${q || ""}&page=${page || 1}&n_records=${
            limit || 50
          }`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["activities"],
    }),
  }),
});

export const {
  useGetTokenMutation,
  useGetActivitiesQuery,
  useGetMapActivitiesQuery,
  useLazyGetMapActivitiesQuery,
  useManualMatchMutation,
  useGetCategoryActivitiesQuery,
  useSearchAllActivitiesQuery,
  useLazySearchAllActivitiesQuery,
} = activitiesApi;
